import $ from '@nuskin/nuskinjquery';

const ScrollUtil = function() {
    'use strict';
    const RESPONSIVE_MAX_SCREEN_WIDTH = 750;

    const SCROLL_TIMEOUT = 600; // Time is in milliseconds.
    const SCROLL_SPEED = 400; // Time is in milliseconds.
    const SCROLL_NEXT_DELAY = 250; // Time is in milliseconds.

    // ---------------------------------------------
    //
    //        Public Methods
    //
    // ---------------------------------------------
    const publicMethods = {
        // ---------------------------------------------
        //
        //        Section scrolling methods
        //
        // ---------------------------------------------
        scrollToSection: function(section) {
            switch (section) {
                case 'firstAddress':
                    ScrollUtil.scrollToFirstAddressSection();
                    break;
                case 'orderDetails':
                    ScrollUtil.scrollToOrderDetailsSection();
                    break;
                case 'shipping':
                    ScrollUtil.scrollToShippingSection();
                    break;
                case 'payment':
                    ScrollUtil.scrollToPaymentSection();
                    break;
                case 'adrOptions':
                    ScrollUtil.scrollToAdrOptionsSection();
                    break;
                case 'reviewOrder':
                    ScrollUtil.scrollToReviewOrderSection();
                    break;
            }
        },
        scrollToNextSection: function(fromSection, hasAdr) {
            setTimeout(function() {
                switch (fromSection) {
                    case 'shipping':
                        ScrollUtil.scrollToShipMethodSection();
                        break;
                    case 'payment':
                        // If we have adr options showing we scroll there.
                        if (hasAdr) {
                            ScrollUtil.scrollToAdrOptionsSection();
                        } else {
                            ScrollUtil.scrollToReviewOrderSection();
                        }
                        break;
                    case 'adrOptions':
                        ScrollUtil.scrollToReviewOrderSection();
                        break;
                }
            }, SCROLL_NEXT_DELAY);
        },


        scrollToFirstAddressSection: function(callback) {
            scrollToSectionUsingSelector($('#firstAddressSection'), callback);
        },

        scrollToOrderDetailsSection: function(callback) {
            scrollToSectionUsingSelector($('#checkout-order-details').parent(), callback);
        },
        scrollToShippingSection: function(callback) {
            scrollToSectionUsingSelector($('#checkout-shipping-selector').parent(), callback);
        },
        scrollToShipMethodSection: function(callback) {
            scrollToSectionUsingSelector($('#checkout-shipping-method').parent(), callback);
        },
        scrollToPaymentSection: function(callback) {
            scrollToSectionUsingSelector($('#checkout-payment-selector').parent(), callback);
        },
        scrollToAdrOptionsSection: function(callback) {
            scrollToSectionUsingSelector($('#checkout-adrOptions').parent(), callback);
        },
        scrollToReviewOrderSection: function(callback) {
            scrollToSectionUsingSelector($('#checkout-review-order').parent(), callback);
        },

        // ---------------------------------------------
        //
        //        Error scrolling methods
        //
        // ---------------------------------------------
        scrollToCheckoutErrorSummary: function(callback) {
            scrollToSectionUsingSelector($('#checkoutErrorSummary'), callback);
        }
    };

    // ---------------------------------------------
    //
    //        Private Methods
    //
    // ---------------------------------------------
    function getWindowWidth() {
        return $('html').width();
    }
    function scrollToSectionUsingSelector(selector, callback) {
        setTimeout(function() {
            let offset = selector.offset().top;

            // Add in some offset for the responsive header if it is showing.
            if (getWindowWidth() <= RESPONSIVE_MAX_SCREEN_WIDTH) {
                if ($('#header').height() && $('#headerDivider').height()) {
                    offset -= ($('#header').height() + $('#headerDivider').height());
                }
            }

            if (typeof callback === 'function') {
                callback();
            }

            // if(navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/)) {
            // selector[0].scrollIntoView();
            // } else {
            $('body, html').animate({scrollTop: offset}, SCROLL_SPEED);
            // }
        }, SCROLL_TIMEOUT);
    }

    return publicMethods;
}();

export default ScrollUtil;
